import type { RouteRecordRaw } from "vue-router";
const onError = (err: any) => {
  console.error("Failed to load async component: ", err);
  throw new Error(err);
};

const Clue: RouteRecordRaw = {
  name: "线索管理",
  path: "/clue",
  component: () => import("@/components/Layout/index.vue").catch(onError),
  redirect: "/clue/demand-pool",
  meta: {
    key: "/clue"
  },
  children: [
    {
      name: "需求池",
      path: "demand-pool",
      meta: {
        key: "/clue/demand-pool"
      },
      component: () =>
        import("@/views/Clue/DemandPool/index.vue").catch(onError)
    },

    {
      name: "线索池",
      path: "clue-manage",
      meta: {
        key: "/clue/clue-manage"
      },
      component: () =>
        import("@/views/Clue/ClueManage/index.vue").catch(onError)
    }
  ]
};

export default Clue;
